import { create } from 'zustand';

interface PaletteState {
  open: boolean;
  toggle: () => void;
  close: () => void;
  openIt: () => void;
}

export const usePalette = create<PaletteState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  close: () => set({ open: false }),
  openIt: () => set({ open: true }),
}));
